export default __webpack_public_path__ + "static/media/icon-content.9cef3d23.svg";